import React, { useEffect, useState } from 'react';
import { RadioButton, RadioButtonGroup } from 'material-ui';
import { orderNew as defaultValues } from 'mocks/cargo/orderNew';
import _ from 'lodash';

export const RadioElement = ({
    value, checkedValue, label = '', onCheck = () => {}, disabled = false, _key,
}) => {
    const [valueSelected, setValueSelected] = useState(checkedValue);

    useEffect(() => {
        setValueSelected(checkedValue);
    }, [checkedValue]);
    
    return (
        <RadioButtonGroup key={_key} name={label} onChange={onCheck} valueSelected={valueSelected}>
            <RadioButton
                label={label.toUpperCase()}
                value={value}
                disabled={disabled}
                style={{
                    height: '48px',
                }}
                labelStyle={{
                    fontSize: '14px',
                    fontWeight: '500',
                    lineHeight: '22px',
                    marginTop: '12px',
                }}
                iconStyle={{
                    marginTop: '6px',
                }}
            />
        </RadioButtonGroup>
    );
};

/**
 * 
 * @param {string | undefined} field 
 */
export const getDefaultCargoRequestValue = (field) => {
    switch (field) {
    case 'packing':
        return _.cloneDeep(defaultValues.cargo[0].packing);
    case 'density':
        return _.cloneDeep(defaultValues.cargo[0].packing.pack.densities[0]);
    case 'containerDetails':
        return _.cloneDeep(defaultValues.cargo[0].containerDetails);
    case undefined:
    default:
        return _.cloneDeep(defaultValues);
    }
};

export const TRANSPORTATION_ALL = ['breakbulk', 'bulk', 'container', 'wetbulk'];

export const CATEGORIES_ALL = [
    'bulk', 'unpacked', 'packed', 'loose', 'wetBulk', 'container',
];

export const getPackingTransportation = (cargoType) => {
    switch (cargoType) {
    case 'Metals & Steel Products': 
        return {
            breakbulk: ['packed', 'loose'],
            bulk: ['bulk'],
            container: ['container'],
        };
    case 'Forest Products': 
        return {
            breakbulk: ['packed', 'loose'],
            bulk: ['bulk'],
            container: ['container'],
        };
    case 'Equipment & Machinery': 
        return {
            breakbulk: ['unpacked'],
            container: ['container'],
        };
    case 'Grains & Agricultural Products': 
        return {
            breakbulk: ['packed'],
            bulk: ['bulk'],
            container: ['container'],
            wetbulk: ['wetBulk'],
        };
    case 'Fertilizers': 
        return {
            breakbulk: ['packed'],
            bulk: ['bulk'],
            container: ['container'],
            wetbulk: ['wetBulk'],
        };
    case 'Oil & Chemicals': 
        return {
            breakbulk: ['packed'],
            bulk: ['bulk'],
            container: ['container'],
            wetbulk: ['wetBulk'],
        };
    case 'Minerals and Rocks': 
        return {
            breakbulk: ['packed'],
            bulk: ['bulk'],
            container: ['container'],
        };
    case 'Food and Beverages': 
        return {
            breakbulk: ['packed'],
            bulk: ['bulk'],
            container: ['container'],
            wetbulk: ['wetBulk'],
        };
    case 'Perishables': 
        return {
            breakbulk: ['packed'],
            bulk: ['bulk'],
            container: ['container'],
        };
    case 'Live Stock': 
        return {
            breakbulk: ['unpacked'],
            container: ['container'],
        };
    case 'Organic Material': 
        return {
            breakbulk: ['packed'],
            bulk: ['bulk'],
            container: ['container'],
        };
    case 'Consumer Goods': 
        return {
            breakbulk: ['unpacked', 'packed'],
            container: ['container'],
        };
    case 'Project & General cargo': 
        return {
            breakbulk: ['unpacked', 'packed'],
            container: ['container'],
        };
    case 'Containers': 
        return {
            container: ['container'],
        };
    case 'Other': 
    default:
        return {
            breakbulk: CATEGORIES_ALL,
            bulk: CATEGORIES_ALL,
            container: CATEGORIES_ALL,
            wetbulk: CATEGORIES_ALL,
        };
    }
};

export const getPackingForBreakBulk = (details) => {
    switch (details) {
    case 1: 
        return ['unpacked'];
    case 2: 
        return ['unpacked', 'packed'];
    case 3: 
        return ['loose', 'packed'];
    case 4: 
        return ['packed'];
    case 5: 
        return ['loose'];
    case 6: 
        return ['loose', 'packed'];
    case 7: 
        return ['packed'];
    case 8: 
        return ['packed'];
    case 9: 
        return ['packed'];
    case 10: 
        return ['unpacked', 'packed'];
    case 11: 
        return ['unpacked'];
    case 12: 
        return ['unpacked'];
    case 13: 
        return ['unpacked'];
    case 14: 
        return ['unpacked'];
    default:
        return CATEGORIES_ALL;
    }
};

export const CONTAINER_TYPES = [
    { name: '20\' Standard Container' },
    { name: '20\' Specialized Container' },
    { name: '20\' Closed Top Container' },
    { name: '20\' Flatrack Container' },
    { name: '20\' High Cube Container' },
    { name: '20\' Open Top Container' },
    { name: '20\' Open Top/Hard Top Container' },
    { name: '20\' Open Top High Cube Container' },
    { name: '20\' Refrigerated Container' },
    { name: '20\' Tank Container', isTank: true },
    { name: '40\' Standard Container' },
    { name: '40\' Specialized Container' },
    { name: '40\' High Cube Container' },
    { name: '40\' High Cube Refrigerated Container' },
    { name: '40\' Flatrack Container' },
    { name: '40\' Open Top Container' },
    { name: '40\' Open Top/Hard Top Container' },
    { name: '40\' Open Top High Cube Container' },
    { name: '40\' Platform Container' },
    { name: '40\' Refrigerated Container' },
    { name: '40\' Tank Container', isTank: true },
    { name: '45\' Standard Container' },
    { name: '45\' Specialized Container' },
    { name: '45\' High Cube Container' },
    { name: '45\' Refrigerated Container' },
    { name: 'Livestock Container' },
    { name: 'Quadcon Container' },
    { name: 'Tricon Container' },
    { name: '8\' Standard Container' },
    { name: '8\' High Cube Container' },
    { name: '10\' Standard Container' },
    { name: '10\' Specialized Container' },
    { name: '10\' Closed Top Container' },
    { name: '10\' High Cube Container' },
    { name: '10\' Flatrack Container' },
    { name: '10\' Refrigerated Container' },
    { name: '11\' Standard Container' },
    { name: '11\' Open Top Container' },
    { name: '11\' Refrigerated Container' },
    { name: '24\' Specialized Container' },
    { name: '30\' Standard Container' },
    { name: '30\' Specialized Container' },
    { name: '30\' High Cube Container' },
    { name: '50\' Standard Container' },
    { name: '53\' Standard Container' },
    { name: '53\' Specialized Container' },
    { name: '53\' High Cube Container' },
];

export const OWNER_TYPES = [
    {
        name: 'shipper',
        value: 'Shipper’s Owned',
    },
    {
        name: 'carrier',
        value: 'Carrier\'s Owned',
    },
    {
        name: 'liner',
        value: 'Liner Owned',
    },
    {
        name: 'leased',
        value: 'Leased',
    },
];

export const NOT_RESET_FIELDS = [
    'unitsWeight', 'unitsVolume', 'temperatureMin', 'temperatureMax',
    'moistureMin', 'moistureMax', 'numberOfHeadsMin', 'numberOfHeadsMax',
    'weightPerHead', 'ventilation', 'bundlesQuantity', 'unitsQuantity', 
    'unitVolume', 'unitWeight',
];

/**
 * @param {any} from
 * @param {string} valuePath
 * @param {boolean} [disabled]
 * @param {any} [toDefault] 
 */
export const displayValue = (from, valuePath, disabled = false, toDefault = '') => {
    if (disabled) {
        return toDefault;
    } 
    return _.get(from, valuePath, toDefault);
};



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/common.jsx